/**
 * Follows the CSS specification behavior for min and max
 * If min > max, then the min have priority
 */
export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, value))
